import { render, staticRenderFns } from "./submissions.vue?vue&type=template&id=4a9895b1&scoped=true&"
import script from "./submissions.vue?vue&type=script&lang=js&"
export * from "./submissions.vue?vue&type=script&lang=js&"
import style0 from "./submissions.vue?vue&type=style&index=0&id=4a9895b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9895b1",
  null
  
)

export default component.exports